import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "semantic-ui-css/semantic.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  // Client ID: 400514316835-22j7iuba1db11vs6un3047nhvif54khg.apps.googleusercontent.com
  // Client Secret: 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
  <GoogleOAuthProvider clientId="400514316835-22j7iuba1db11vs6un3047nhvif54khg.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
